/**
 * 通用js方法封装处理
 * Copyright (c) 2019
 */

function getEnv() {
	if (location.hostname === 'localhost') return 'dev'
	if (["test", "pre"].includes(GLOBAL_ENV)) {
		return GLOBAL_ENV
	}
	return 'prod';
}
const API_MAP = {
	'test': location.hostname.match(/[a-zA-Z]+/) ? 'https://iadmtest.jieyue.com' : location.origin,
	'pre': 'https://iadmpre.jieyue.com',
	'prod': 'https://iadm.jieyue.com',
	'dev': '/'
}

export const baseURL = API_MAP[getEnv()]


// 日期格式化
export function parseDate(dete, pattern) {
	if (arguments.length === 0 || !date) {
		return null
	}
	const format = pattern || '{y}-{m}-{d}'
	let date
	if (typeof dete === 'object') {
		date = dete
	} else {
		if ((typeof dete === 'string') && (/^[0-9]+$/.test(dete))) {
			date = parseInt(date)
		}
		if ((typeof dete === 'number') && (dete.toString().length === 10)) {
			dete = dete * 1000
		}
		date = new Date(dete)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
	}
	const date_str = format.replace(/{(y|m|d)+}/g, (result, key) => {
		let value = formatObj[key]
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return date_str
}

// 日期时间格式化
export function parseTime(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

// 表单重置
export function resetForm(refName) {
	if (this.$refs[refName]) {
		this.$refs[refName].resetFields();
	}
}

// 添加日期范围
export function addDateRange(params, dateRange) {
	var search = params;
	search.beginTime = "";
	search.endTime = "";
	if (null != dateRange && '' != dateRange) {
		search.beginTime = this.dateRange[0];
		search.endTime = this.dateRange[1];
	}
	return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
	var actions = [];
	Object.keys(datas).map((key) => {
		if (datas[key].dictValue == ('' + value)) {
			actions.push(datas[key].dictLabel);
			return false;
		}
	})
	return actions.join('');
}

// 通用下载方法
export function download(fileName) {
	window.location.href = baseURL + "/common/download?fileName=" + encodeURI(fileName) + "&delete=" + true;
}

export function downloadFile(fileName) {
	window.location.href = baseURL + "/common/ossDownload?fileName=" + encodeURI(fileName);
}

export function downloadCode(fileName, destFileName) {
	window.location.href = baseURL + "/common/ossDownloadFile?fileName=" + encodeURI(fileName) + "&destFileName=" + encodeURI(destFileName) + '.png';
}

// 字符串格式化(%s )
export function sprintf(str) {
	var args = arguments, flag = true, i = 1;
	str = str.replace(/%s/g, function () {
		var arg = args[i++];
		if (typeof arg === 'undefined') {
			flag = false;
			return '';
		}
		return arg;
	});
	return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
	if (!str || str == "undefined" || str == "null") {
		return "";
	}
	return str;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
	id = id || 'id'
	parentId = parentId || 'parentId'
	children = children || 'children'
	rootId = rootId || '0'
	//对源数据深度克隆
	const cloneData = JSON.parse(JSON.stringify(data))
	//循环所有项
	const treeData = cloneData.filter(father => {
		let branchArr = cloneData.filter(child => {
			//返回每一项的子级数组
			return father[id] === child[parentId]
		});
		branchArr.length > 0 ? father.children = branchArr : '';
		//返回第一层
		return father[parentId] === rootId;
	});
	return treeData != '' ? treeData : data;
}

/**
 * 表格时间格式化
 * isTime为true显示时间，为flase只显示日期
 *
 *
 */
export function formatDate(cellValue, isTime) {
	var cellValue = cellValue;
	if (cellValue == null || cellValue == "") return "";
	// console.log(66,cellValue,typeof(cellValue))
	if (cellValue.length > 19 || typeof (cellValue) == 'object') {
		var dateVal = cellValue;
		var date = new Date(dateVal)
		var year = date.getFullYear()
		var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
		var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
		var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
		var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
		var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
		if (isTime) {
			return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
		} else {
			return year + '-' + month + '-' + day
		}
	} else {
		if (isTime) {
			return cellValue;
		} else {
			return cellValue.substring(0, 10);
		}
	}
}
/**
 * 表格时间格式化
 * isTime为true显示时间，为flase只显示日期
 *
 *
 */
export function formatDate2(cellValue, isTime) {
	if (cellValue == null || cellValue == "") return "";
	var date = new Date(cellValue)
	var year = date.getFullYear()
	var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
	var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
	var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
	var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
	var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
	if (isTime) {
		return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
	} else {
		return year + '-' + month + '-' + day
	}

}

// 通用上传方法
export const uploadUrl = baseURL + '/common/upload';
export const uploadFile = baseURL + '/common/uploadLocal';
export const uploadAll = baseURL + '/common/uploadEditor';
export const uploadSystemFile = baseURL + '/common/fileSystem/upload';

export const imgUrl = "https://oss.jieyue.com/";
